import React from 'react'
import AccountingTransactionsShell from 'src/app/AccountingTransactionsShell/AccountingTransactionsShell'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountingReviewReportsRouteProps } from 'src/navigation/routeProps'

const AccountingReviewReportsAppRoute: AppRoute = {
  id: AppLocation.AccountingReviewReports,
  routeProps: accountingReviewReportsRouteProps,
  component: <AccountingTransactionsShell />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountingReviewReportsAppRoute
